import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=02389e04&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=02389e04&prod&lang=scss&scoped=true&"
import style1 from "./Product.vue?vue&type=style&index=1&id=02389e04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02389e04",
  null
  
)

export default component.exports